<p-dialog
  [(visible)]="display"
  modal="modal"
  width="500"
  [responsive]="true"
  (onHide)="onClosePopUp()"
>
  <p-header>
    {{
      (isRegenerate ? 'label.EnterYear' : 'label.EnterAnnouncementId')
        | translate
    }}
  </p-header>
  <div style="display: table">
    <div *ngIf="!isRegenerate" style="display: table-row">
      <div class="cell--label">{{ 'label.AnnouncementId' | translate }}:</div>
      <div style="display: table-cell">
        <input type="text" class="form-control" [(ngModel)]="announcementId" />
        <hr-field-state-marker
          [field]="field?.announcementId"
        ></hr-field-state-marker>
      </div>
    </div>
    <div style="display: table-row">
      <div class="cell--label">Last jobseeker activity:</div>
      <div style="display: table-cell">
        <p-dropdown
          [options]="years"
          appendTo="body"
          [(ngModel)]="selectedYear"
          placeholder="year"
        >
        </p-dropdown>
        <hr-field-state-marker [field]="field?.year"></hr-field-state-marker>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <button
      *ngIf="!isRegenerate"
      pButton
      type="button"
      (click)="onGenerateAnnouncementMatching()"
      label="{{ 'label.Generate' | translate }}"
    ></button>
    <button
      *ngIf="isRegenerate"
      pButton
      type="button"
      (click)="onRegenerate()"
      label="{{ 'label.Regenerate' | translate }}"
    ></button>
    <p-button
      type="button"
      (click)="onClosePopUp()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
<p-button
  type="button"
  class="ui-button-secondary"
  *ngIf="!isRegenerate"
  (click)="onGenerate()"
  label="{{ 'label.GenerateForAnnouncement' | translate }}"
></p-button>
<p-button
  type="button"
  class="ui-button-secondary"
  *ngIf="isRegenerate"
  (click)="onGenerate()"
  label="{{ 'label.Regenerate' | translate }}"
></p-button>
